export default __webpack_public_path__ + "static/media/durable.47dd9ff1.png";